<template>
  <article class="article is-relative">
    <img
      class="article__thumbnail thumbnail"
      alt="Thumbnail"
      :src="thumbnailPath"
    />
    <div class="article__info">
      <span>
        <span v-if="authors">Por | </span>
        <template v-for="(autor, index) in authors" :key="index">
          <span class="article__author">{{ autor }}</span
          >{{ authors.length - 1 != index ? "; " : "" }}{{ " " }}
        </template>
        <small v-if="publisher">{{ " " }}{{ publisher }}</small>
        <small v-if="dateIssued"> ({{ dateIssued }})</small>
      </span>
      <h3 class="article__title">
        <a class="mock" :href="sourcePath" target="_blank" :title="title">
          {{ title }}
        </a>
      </h3>
      <p class="article__abstract">
        {{ abstract }}
      </p>
    </div>
  </article>
</template>
<script>
export default {
  components: {},
  props: {
    type: {
      type: String,
      default: "simple",
      validator(value) {
        return ["simple", "complex"].includes(value);
      }
    },
    number: {
      type: Number,
      default: 0
    },
    sourcePath: {
      type: String
    },
    thumbnailPath: {
      type: String
    },
    title: {
      type: String,
      default: ""
    },
    authors: {
      type: Array,
      default: () => []
    },
    dateIssued: {
      type: String,
      default: ""
    },
    publisher: {
      type: String,
      default: ""
    },
    abstract: {
      type: String
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.article {
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 120px auto;
  margin: 2rem 0;
  &__title {
    margin: 0;
    a {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  &__number {
    position: absolute;
    top: 0.5em;
    left: 0.5em;
    background: white;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    border: 2px solid #d9d9d9;
  }
  &__abstract {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 0.8em;
  }
}
</style>
